<template>
  <a-modal
    :open="isDevelop ? false : props.open"
    class="gap-5"
    width="700px"
    :maskClosable="false"
  >
    <template #footer>
      <div class="flex flex-row justify-center gap-5 mt-7">
        <a-button class="w-40 !h-10" @click="onCancel">ยกเลิก</a-button>
        <a-button
          type="primary"
          class="!h-10 !m-0 ant-btn-success"
          @click="$emit('update:open', false)"
          :disabled="!checked"
        >
          คลิกที่นี่เพื่อดำเนินการต่อ
        </a-button>
      </div>
    </template>
    <div class="flex flex-col items-center content-center gap-5">
      <ExclamationTriangleIcon class="w-20 text-crimson" />
      <div class="flex flex-col gap-2">
        <h1 class="text-3xl font-semibold text-center">ผู้สมัครโปรดทราบ</h1>
        <p class="text-xl text-center text-alert">
          สำนักงานเลขาธิการวุฒิสภา
          ได้มีการดำเนินการจัดเก็บข้อมูลส่วนบุคคลของผู้สมัคร
          เพื่อใช้ในการดำเนินการสรรหาเข้าดำรงตำแหน่ง
          ซึ่งผู้สมัครจะต้องให้ความยินยอม
          ในการให้นำข้อมูลไปใช้ในการดำเนินการดังกล่าว ทั้งนี้ เป็นไปตาม
          พ.ร.บ.คุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562
        </p>
      </div>
      <div>
        <a-checkbox v-model:checked="checked">
          ข้าพเจ้ายินยอมรับเงื่อนไข และข้อกำหนดการคุ้มครองข้อมูลส่วนบุคคล
        </a-checkbox>
      </div>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import { ROUTE_NAMES } from "@/router/constants";
import { isDevelop } from "@/utils/helper";
import { ExclamationTriangleIcon } from "@heroicons/vue/24/outline";
import { ref } from "vue";
import { useRouter } from "vue-router";
import type { ModalTwoProps } from "./type";

const router = useRouter();
const props = defineProps<ModalTwoProps>();

defineEmits(["update:open"]);

const checked = ref<boolean>(false);

function onCancel() {
  router.push({ name: ROUTE_NAMES.HOME });
}
</script>
